import {
  ACTIVE_METRICS,
  EMPLOYEE_STATUS_METRICS,
  FEEDBACK_ACTIVITIES_METRICS,
  FEEDBACK_NOTE_METRICS,
  GLOBAL_SELECTORS_KEYS,
  GOAL_METRICS,
  OVERALL_PERFORMANCE_METRICS,
  PREPEND_OPTIONS_ALL,
  TRACKING_CASH_IN_METRICS
} from 'features/command-center/constants';
import isNil from 'lodash/isNil';
import moment from 'moment';
import { userHasRoles } from 'services/Authorization';
import { DateFormats } from 'UI/constants/defaults';
import { Roles } from 'UI/constants/roles';
import { loadFromLocalStorage } from 'UI/utils';

import { ALL_COMPANY_VISIBILITY_ROLES } from '../components/layout/DominateSheetLayout/DominateSheetLayout.constants';

/**
 * The function `getWeekRange` takes a week object as input and returns an object containing the start
 * and end dates of the week.
 * @returns The function `getWeekRange` returns an object with two properties: `startDate` and
 * `endDate`.
 */
export const getWeekRange = week => {
  if (!week) return {};

  const daysToAdd = 6;

  const startDate = week.date;
  const start = new Date(startDate);
  const end = new Date(start);
  end.setDate(end.getDate() + daysToAdd);

  const endDate = end.toISOString().split('T')[0];

  return {
    startDate,
    endDate
  };
};

export const capitalizeName = name => {
  if (!name) return null;
  return name
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const getCoachInitialState = user => {
  const isAssistantRegionalDirector = userHasRoles([Roles.AssistantRegionalDirector]);
  const hasSuperiorRole = userHasRoles(ALL_COMPANY_VISIBILITY_ROLES);

  if (!isAssistantRegionalDirector || hasSuperiorRole)
    return (
      loadFromLocalStorage(GLOBAL_SELECTORS_KEYS.dominate.coach, null) || PREPEND_OPTIONS_ALL[0]
    );

  return {
    email: user?.teamRelation?.coachEmail,
    id: user?.teamRelation?.coachId
  };
};

export const calculateChartLabelInterval = (rangeInDays, maxLabels = 12) => {
  if (rangeInDays <= maxLabels) return 1;

  return Math.ceil(rangeInDays / maxLabels);
};

export const formatDateForChartLabel = dateStr => {
  if (!dateStr) return '';

  return moment(dateStr).format(DateFormats.SimpleDate);
};

export const replaceQueryParams = ({ queryParams, keyParam, valueParam }) => {
  const params = new URLSearchParams(queryParams);
  params.set(keyParam, valueParam);
  return params.toString();
};

export const buildEndpointWithQueryParams = ({
  baseEndpoint,
  queryParams = '',
  metrics = null
}) => {
  const params = new URLSearchParams(queryParams);

  if (!isNil(metrics)) {
    params.set('metrics', metrics);
  }

  const serializedParams = params.toString();

  return serializedParams ? `${baseEndpoint}?${serializedParams}` : baseEndpoint;
};

export const getExcludedMetricsFromColumnPreferences = (columns = []) =>
  columns.filter(({ options }) => options?.display === false).map(({ name }) => name);

export const getOverallPerformanceMetrics = () =>
  [
    ...OVERALL_PERFORMANCE_METRICS,
    ...GOAL_METRICS,
    ...FEEDBACK_NOTE_METRICS,
    ...EMPLOYEE_STATUS_METRICS,
    ...FEEDBACK_ACTIVITIES_METRICS,
    ...ACTIVE_METRICS,
    ...TRACKING_CASH_IN_METRICS
  ].join(',');
